import Vue from 'vue'
import axios from 'axios'

import {
    CsvExporter,
    ExcelExporter,
    CsvWithHistoryExporter,
    ExcelWithHistoryExporter,
    DataToExcelConverter,
    DirectExcelExporter,
    DirectExcelWithHistoryExporter
} from "pbas-vue-components";

export default function(apiUrl) {
    Vue.prototype.$exporters = [
        new CsvExporter(),
        new ExcelExporter(new DataToExcelConverter(Vue.prototype.$axiosHttp, apiUrl))
    ];
    Vue.prototype.$exportersWithHistory = [
        new CsvWithHistoryExporter(),
        new ExcelWithHistoryExporter(new DataToExcelConverter(Vue.prototype.$axiosHttp, apiUrl))
    ];
    Vue.prototype.$directExporters = [
        new CsvExporter(),
        new DirectExcelExporter(new DataToExcelConverter(Vue.prototype.$axiosHttp, apiUrl))
    ];
    Vue.prototype.$directExportersWithHistory = [
        new CsvWithHistoryExporter(),
        new DirectExcelWithHistoryExporter(new DataToExcelConverter(Vue.prototype.$axiosHttp, apiUrl))
    ];
}